@let checkBisCampaignTabs =
  environment.hasCampaignBis && dataService.hasCurrentBisCampaign();

<div class="faq-container">
  @if (
    tabsConfig &&
    checkBisCampaignTabs &&
    config.loyaltychallengeBis &&
    !config.loyaltychallengeBis.afterTitle
  ) {
    <div class="container">
      <b2c-bis-campaign-tabs
        [tabs]="tabsConfig"
        [activeTab]="activeTab()"
        (tabChanged)="changeTab($event)"
      />
    </div>
  }

  <div class="container">
    <ng-container
      *ngComponentOutlet="
        components[config.faqVariant.variant].component;
        inputs: components[config.faqVariant.variant].inputs
      "
    />
  </div>
</div>
